function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ComponentBase } from "./Shared/ComponentBase";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { FormFieldBuilder } from "./Helpers/FormFieldBuilder";
import { FormManager } from "./Helpers/FormManager";
import { PlanYourVisitApiService } from "./Services/PlanYourVisitApiService";
import { Configuration } from "./Shared/Configuration";
import { I18N } from "./Shared/I18n";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { LookupApiService } from "./Services/LookupApiService";
import { AddressAutoComplete } from './Shared/AddressAutoComplete';
import { CommunicationService } from "./Services/CommunicationService";
import { DateTimeFormatter } from "./Helpers/DateTimeFormatter";
export var MppPlanYourVisit = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppPlanYourVisit, _ComponentBase);

  var _super = _createSuper(MppPlanYourVisit);

  function MppPlanYourVisit() {
    var _this;

    _classCallCheck(this, MppPlanYourVisit);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "_ApplyAddress", function (address) {
      if (!!address) {
        var addressLine1Element = _this._root.querySelector("input[name=\"HouseholdAddress.AddressLine1\"]");

        addressLine1Element.value = address.addressLine1 || "";

        var cityElement = _this._root.querySelector("input[name=\"HouseholdAddress.City\"]");

        cityElement.value = address.city || "";

        var stateRegionElement = _this._root.querySelector("input[name=\"HouseholdAddress.StateOrProvince\"]");

        stateRegionElement.value = address.state || "";

        var postalCodeElement = _this._root.querySelector("input[name=\"HouseholdAddress.PostalCode\"]");

        postalCodeElement.value = address.postalCode || "";

        var countryElement = _this._root.querySelector("#countryId");

        for (var idx in countryElement.options) {
          var option = countryElement.options[idx];

          if (option.innerHTML == address.country) {
            countryElement.value = option.value;
            break;
          }
        }
      }
    });

    _this._childDivCounter = 0; // Keep track of number of child house member divs

    _this._visitDetailsForm = [];
    _this._congregationId = 0;

    _this._PlanYourVisitInit();

    _this._dateFormatter = new DateTimeFormatter();
    return _this;
  }

  _createClass(MppPlanYourVisit, [{
    key: "_PlanYourVisitInit",
    value: function _PlanYourVisitInit() {
      this._addressAutoComplete = new AddressAutoComplete(this._root);
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.verificationEmailTemplate = this.getAttribute("verificationemailtemplateId") || "";
      this.userNotificationEmailTemplate = this.getAttribute("userNotificationemailtemplateid") || "";
      this.churchNotificationEmailTemplate = this.getAttribute("churchnotificationemailtemplateid") || "";
      this.collectAddress = this.getAttribute("collectaddress") || "";
      this.milestoneToAssign = this.getAttribute("milestonetoassignid") || "";
      this.milestoneProgram = this.getAttribute("milestoneprogramid") || "";
      this.returnUrl = this.getAttribute("returnurl") || "";
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$mppPlanYourVisitContainer) {
        this.connectedCallback();
      }
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppPlanYourVisit.WidgetDetails.tag);
    } // istanbul ignore next

  }, {
    key: "getPlanYourVisitApiService",
    value: function getPlanYourVisitApiService() {
      return new PlanYourVisitApiService();
    } // istanbul ignore next

  }, {
    key: "getFormFieldBuilder",
    value: function getFormFieldBuilder() {
      return new FormFieldBuilder();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  this._$emptyContainer.innerHTML = "";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                  this._$emptyContainer.innerHTML = "";
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n;
                this._formFieldBuilder = this.getFormFieldBuilder(); // Load attributes

                this.loadAttributes();
                this._planYourVisitService = this.getPlanYourVisitApiService(); // Load page data

                this.LoadPage();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }() // End connectedCallback

  }, {
    key: "LoadPage",
    value: function LoadPage() {
      // Check if returnUrl attribute has a value
      var href = window.location.href;
      var url = new URL(href);
      var mppVerifyId = url.searchParams.get("mpp-verify-id"); // Next check to see if returnUrl has a mppVerifyId= value set

      if (!!mppVerifyId) {
        // If so then display register page
        this.SetupRegistrationForm(this._i18n, mppVerifyId);
      } else {
        // Else display intitial verify form
        this.SetupInitialForm(this._i18n); // Try logging in user

        this.TryLoginUser();
      }
    }
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this2 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        // If logged in hide plan your visit form and buttons
        _this2.HideVerificationForm();

        _this2.SetMessage("warning", _this2._i18n.userLoggedInMessage);
      }, function () {
        // If not logged in show plan your visit form and buttons
        _this2.ShowVerificationForm();
      });
    }
  }, {
    key: "SetupRegistrationForm",
    value: function SetupRegistrationForm(i18n, mppVerifyId) {
      // Setup div to handle any errors
      this._setupRoot();

      this.initElementSelectors(); // Verify id

      this._verifyEmailLink(mppVerifyId, i18n);
    }
  }, {
    key: "_verifyEmailLink",
    value: function _verifyEmailLink(mppVerifyId, i18n) {
      var _this3 = this;

      return this._planYourVisitService.VerifyEmailLink(mppVerifyId).then(function (verifyResponse) {
        var i18NMessage = _this3.GetI18NMessageByName(i18n, verifyResponse.i18NLabelName);

        if (verifyResponse.success === 'true') {
          _this3.userToRegister = verifyResponse;
          _this3._root.innerHTML = _this3.BuildRootRegisterHtml(i18n);

          _this3.SetupRegistrationFormVariables(i18n);
        } else {
          // Display warning message
          _this3.SetMessage("warning", i18NMessage);
        }
      })["catch"](function (error) {
        _this3.SetMessage("danger", i18n.verificationFailedMessage);
      })["finally"](function () {
        _this3._$emptyContainer.innerHTML = "";
      });
    } // istanbul ignore next

  }, {
    key: "initElementSelectors",
    value: function initElementSelectors() {
      this._$mppPlanYourVisitContainer = this._root.querySelector("#mpp-plan-your-visit-container"); // Error/success message elements

      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText"); // Empty container, holds the loading spinner

      this._$emptyContainer = this._root.querySelector("#emptyContainer");
    }
  }, {
    key: "_setupRoot",
    value: function _setupRoot() {
      this._root.innerHTML = "\n\t\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\n\t\t\t\t<div id=\"mpp-plan-your-visit-container\" class=\"mppw-component-container mpp-plan-your-visit\">\n\n\t\t\t\t<div id=\"emptyContainer\"><i class=\"mppw-spinner\"></i></div>\n\t\t\t\t<div id=\"detailsContainer\"></div>\n\n\t\t\t\t<div id=\"resultMessageContainer\" class=\"mppw-alert\" style=\"display: none;\">\n\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t<span id=\"resultMessageText\" class=\"mppw-alert__text\"></span>\n\t\t\t\t</div>\n\t\t\t\t</div>");
    }
  }, {
    key: "SetupRegistrationFormVariables",
    value: function () {
      var _SetupRegistrationFormVariables = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(i18n) {
        var lookupService, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Visit details elements
                this._GetFormElementReferences();

                lookupService = new LookupApiService();
                _context2.prev = 2;
                _context2.next = 5;
                return this._planYourVisitService.GetConfigurations();

              case 5:
                data = _context2.sent;

                this._LoadCongregationsDropdown(data, i18n);

                this.GetAgeOrAgeGradeDropdown(i18n);

                if (this.collectAddress === "true") {
                  this._LoadCountryDropdown(data, i18n);
                }

                this._gendersData = data.genders;
                this._phoneMask = data.phoneMask; // Set phone number mask

                this.SetPhoneMask("HeadOfHousehold.Contact.MobilePhoneNumber"); // Add the Spouse div to the form

                this.AddSpouseDiv(i18n); // Set formmanager

                this._visitDetailsForm = this._GetFormData(this._$visitDetailsForm); // Wire-up event listeners:

                this.BindEventHandlers(i18n);

                if (this.collectAddress === "true") {
                  this._InitAddress();
                }

                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](2);
                console.error(_context2.t0);

              case 21:
                this._$emptyContainer.innerHTML = "";

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 18]]);
      }));

      function SetupRegistrationFormVariables(_x) {
        return _SetupRegistrationFormVariables.apply(this, arguments);
      }

      return SetupRegistrationFormVariables;
    }()
  }, {
    key: "_InitAddress",
    value: function _InitAddress() {
      var addressElement = this._root.querySelector("input[name=\"HouseholdAddress.AddressLine1\"]");

      this._addressAutoComplete.attach(addressElement, this._ApplyAddress);
    } // istanbul ignore next

  }, {
    key: "_GetFormData",
    value: function _GetFormData(formId) {
      return new FormManager(formId);
    }
  }, {
    key: "_LoadCountryDropdown",
    value: function _LoadCountryDropdown(data, i18n) {
      DropdownBuilder.LoadDropdown(this._$countryId, data.countries, i18n.countryPlaceholderText); // Set United States as default

      var dropdownOptions = this._$countryId.options;

      for (var opt, j = 0; opt = dropdownOptions[j]; j++) {
        if (opt.textContent.toString().toLowerCase() === 'united states of america') {
          dropdownOptions.selectedIndex = j;
          break;
        }
      }
    }
  }, {
    key: "_LoadCongregationsDropdown",
    value: function _LoadCongregationsDropdown(data, i18n) {
      DropdownBuilder.LoadDropdown(this._$congregationId, data.congregations, i18n.congregationPlaceHolderText);
      this._$congregationId.value = data.congregations[0].id;

      this._$congregationId.remove(0);
    } // istanbul ignore next

  }, {
    key: "_GetFormElementReferences",
    value: function _GetFormElementReferences() {
      this._$visitDetailsContainer = this._root.querySelector("#visitDetailsContainer");
      this._$visitDetailsFormContainer = this._root.querySelector("#visitDetailsFormContainer");
      this._$visitDetailsForm = this._root.querySelector("#visitDetailsForm");
      this._$submitRegistrationButton = this._root.querySelector("#submitRegistrationButton");
      this._$congregationId = this._root.querySelector("#congregationId");
      this._$countryId = this._root.querySelector("#countryId"); // Empty container, holds the loading spinner

      this._$emptyContainer = this._root.querySelector("#emptyContainer"); // Error/success message elements

      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText"); // Invalid email message container

      this._$invalidDetailsEmailContainer = this._root.querySelector("#invalidDetailsEmailTemplateContainer");
      this._gendersData = [];
      this._ageOrGradeData = [];
      this._phoneMask = ""; // Spouse elements

      this._$insertSpouseDiv = this._root.querySelector("#insertSpouseDiv"); // Children elements

      this._$addChildButton = this._root.querySelector("#addChildButton");
      this._$removeChildClass = this._root.querySelector(".removeChildClass");
      this._$childMembersContainer = this._root.querySelector("#childMembersContainer");
      this._$insertChildDiv = this._root.querySelector("#insertChildDiv");
    }
  }, {
    key: "BindEventHandlers",
    value: function BindEventHandlers(i18n) {
      var _this4 = this;

      // Listen for adding child event click
      this._$addChildButton.addEventListener("click", function (event) {
        event.preventDefault();

        _this4.AddChildDiv(i18n); // Re-bind formmanager


        _this4._visitDetailsForm = new FormManager(_this4._$visitDetailsForm);
      }); // Listen for congregation dropdown changes


      this._$congregationId.addEventListener("change", function (event) {
        // Set congregationid
        _this4._congregationId = event.target.value;

        _this4.GetAgeOrAgeGradeDropdown(i18n, event.target.value); // Also check for valid email templates


        _this4.CheckForValidEmailTemplate(event.target.value);
      }); // Listen for submit form click


      this._$submitRegistrationButton.addEventListener("click", function (event) {
        event.preventDefault();
        _this4._visitDetailsForm = new FormManager(_this4._$visitDetailsForm);

        if (_this4._visitDetailsForm.IsValid()) {
          // Disable submit button to prevent duplicate submissions
          _this4.DisableSubmitButton(); // Hide any previous messages


          _this4.HideMessage();

          var formData = new FormData(_this4._$visitDetailsForm);
          formData.append("MilestoneToAssignId", _this4.milestoneToAssign);
          formData.append("MilestoneProgramId", _this4.milestoneProgram); // Submit form to api service

          _this4._saveVisitDetailsService(formData, i18n);
        } else {
          _this4.SetMessage("warning", i18n.validationFailedMessage);
        }
      });
    }
  }, {
    key: "_saveVisitDetailsService",
    value: function _saveVisitDetailsService(formData, i18n) {
      var _this5 = this;

      return this._planYourVisitService.SaveVisitDetails(formData).then(function (registrationResponse) {
        var i18NMessage = _this5.GetI18NMessageByName(i18n, registrationResponse.i18NLabelName);

        if (registrationResponse.success === true) {
          // Display success message
          _this5.SetMessage("success", i18NMessage);

          _this5._visitDetailsForm.Reset();

          _this5.HideVisitDetailsForm();
        } else {
          // Display warning message
          _this5.SetMessage("warning", i18NMessage);
        }
      })["catch"](function (error) {
        console.error(error);

        _this5.SetMessage("danger", i18n.verificationFailedMessage);
      })["finally"](function () {
        // Need to make sure to re-enable the button once finished
        _this5.EnableSubmitButton();
      });
    }
  }, {
    key: "CheckForValidEmailTemplate",
    value: function CheckForValidEmailTemplate(congregationId) {
      var _this6 = this;

      this._$invalidDetailsEmailContainer.innerHTML = ''; // Check for valid plan a visit template

      this._planYourVisitService.GetPlanAVisitTemplate(congregationId).then(function (data) {
        if (data) {// Valid email template
        } else {
          // Display invalid email template message
          _this6._$invalidDetailsEmailContainer.innerHTML +=  `<div id="invalidEmailTemplate" class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">Invalid Email Template. Saving the record is allowed, however no email notifications will be sent.</span></div>` ;
        }
      })["catch"](function (error) {
        // Display invalid email template message
        _this6._$invalidDetailsEmailContainer.innerHTML +=  `<div id="invalidEmailTemplate" class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">Invalid Email Template. Saving the record is allowed, however no email notifications will be sent.</span></div>` ;
      });
    }
  }, {
    key: "SetupInitialForm",
    value: function SetupInitialForm(i18n) {
      this._root.innerHTML = this.BuildRootInitialHtml(i18n);
      this.SetupInitialFormVariables(i18n);
    } // istanbul ignore next

  }, {
    key: "getFormManager",
    value: function getFormManager(VerifyForm) {
      return new FormManager(VerifyForm);
    }
  }, {
    key: "SetupInitialFormVariables",
    value: function SetupInitialFormVariables(i18n) {
      var _this7 = this;

      // Select items from template.  Use $ as convention indicating a DOM element:
      // InnerHTML
      this._initialElementsForFormVariables(); // Wire-up event listeners:


      var verificationForm = this.getFormManager(this._$verificationForm);
      var communicationService = new CommunicationService(); // Check for valid email template

      this._checkEmailTemplate(communicationService);

      this._$loginButton.addEventListener("click", function () {
        OAuthService.SignIn();
      });

      this._$verificationForm.addEventListener("submit", function (event) {
        event.preventDefault();

        if (verificationForm.IsValid()) {
          // Disable submit button to prevent duplicate submissions
          _this7.DisableVerificationButton(); // Hide any previous messages


          _this7.HideMessage();

          var formData = new FormData(_this7._$verificationForm);
          formData.append("ReturnUrl", _this7.returnUrl);

          _this7._sendVerificationEmailService(formData, i18n, verificationForm);
        } else {
          _this7.SetMessage("warning", i18n.validationFailedMessage);
        }
      });

      this._$emptyContainer.innerHTML = "";
    }
  }, {
    key: "_sendVerificationEmailService",
    value: function _sendVerificationEmailService(formData, i18n, verificationForm) {
      var _this8 = this;

      return this._planYourVisitService.SendVerificationEmail(formData).then(function (sendEmailResponse) {
        var i18NMessage = _this8.GetI18NMessageByName(i18n, sendEmailResponse.i18NLabelName);

        if (sendEmailResponse.success === true) {
          // Display success message
          _this8.SetMessage("success", i18NMessage);

          verificationForm.Reset();

          _this8.HideVerificationForm();
        } else {
          // Display warning message
          _this8.SetMessage("warning", i18NMessage);

          if (sendEmailResponse.successErrorMessage.toLowerCase() === 'contact exists') {
            // Show login button
            _this8._$loginButtonContainer.style.display = "";
            verificationForm.Reset(); // Hide user form inputs

            _this8.HideVerificationForm();
          }
        }
      })["catch"](function (error) {
        _this8.SetMessage("danger", i18n.verificationFailedMessage);
      })["finally"](function () {
        // Need to make sure to re-enable the button once finished
        _this8.EnableVerificationButton();
      });
    }
  }, {
    key: "_checkEmailTemplate",
    value: function _checkEmailTemplate(communicationService) {
      var _this9 = this;

      communicationService.GetEmailTemplate(this.verificationEmailTemplate).then(function (data) {
        if (data) {// Valid email template
        } else {
          // Display invalid email template message
          _this9._$invalidVerificationEmailContainer.innerHTML +=  `<div id="invalidEmailTemplate" class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">Invalid Email Template. Saving the record is allowed, however no email notifications will be sent.</span></div>` ;
        }
      })["catch"](function (error) {
        // Display invalid email template message
        _this9._$invalidVerificationEmailContainer.innerHTML +=  `<div id="invalidEmailTemplate" class="mppw-alert mppw-alert__danger"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">Invalid Email Template. Saving the record is allowed, however no email notifications will be sent.</span></div>` ;
      });
    }
  }, {
    key: "_initialElementsForFormVariables",
    value: function _initialElementsForFormVariables() {
      this._$mppPlanYourVisitContainer = this._root.querySelector("#mpp-plan-your-visit-container");
      this._$verfificationContainer = this._root.querySelector("#verfificationContainer");
      this._$visitDetailsContainer = this._root.querySelector("#visitDetailsContainer");
      this._$emptyContainer = this._root.querySelector("#emptyContainer");
      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
      this._$loginButton = this._root.querySelector("#loginButton"); // Verification Form HTML

      this._$verificationForm = this._root.querySelector("#verificationForm");
      this._$verificationButton = this._root.querySelector("#verificationButton");
      this._$verificationBlankForm = this._root.querySelector("#verificationBlankForm");
      this._$verificationfirstNameText = this._root.querySelector("#verification_firstNameText");
      this._$verificationlastNameText = this._root.querySelector("#verification_lastNameText");
      this._$verificationemailText = this._root.querySelector("#verification_emailText"); // Valid email template container

      this._$invalidVerificationEmailContainer = this._root.querySelector("#invalidVerificationEmailContainer");
    }
  }, {
    key: "ShowVerificationForm",
    value: function ShowVerificationForm() {
      this._$verificationForm.style.display = "";

      this._$verificationfirstNameText.setAttribute("required", true);

      this._$verificationlastNameText.setAttribute("required", true);

      this._$verificationemailText.setAttribute("required", true);
    }
  }, {
    key: "HideVerificationForm",
    value: function HideVerificationForm() {
      this._$verificationForm.style.display = "none";

      this._$verificationfirstNameText.removeAttribute("required");

      this._$verificationlastNameText.removeAttribute("required");

      this._$verificationemailText.removeAttribute("required");
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }, {
    key: "HideMessage",
    value: function HideMessage() {
      this._$resultMessageText.innerHTML = "";
      this._$resultMessageContainer.style.display = "none";
    }
  }, {
    key: "HideVisitDetailsForm",
    value: function HideVisitDetailsForm() {
      this._$visitDetailsContainer.style.display = "none";
    } // Data binding between input and display
    // Used to auto-populate first name text for spouse and child when typing

  }, {
    key: "RegisterInputBinding",
    value: function RegisterInputBinding(inputName, displayName) {
      var input = this._baseRoot.getElementById(inputName);

      var display = this._baseRoot.getElementById(displayName); // Listen for keydown event


      input.addEventListener('keydown', logKeyEvent);

      function logKeyEvent(ev) {
        var isCharacter = ev.key.length === 1;
        var isDelete = ev.keyCode === 8 || ev.keyCode === 46;

        if (isCharacter || isDelete) {
          if (isDelete) {
            display.textContent = display.textContent.slice(0, -1);
          }

          if (isCharacter) {
            display.textContent += ev.key;
          }
        }
      }
    }
  }, {
    key: "SetPhoneMask",
    value: function SetPhoneMask(htmlElementId) {
      var phoneMaskElement = this._baseRoot.getElementById(htmlElementId);

      phoneMaskElement.setAttribute("pattern", this._phoneMask);
    }
  }, {
    key: "AddSpouseDiv",
    value: function AddSpouseDiv(i18n) {
      // Insert html
      this._$insertSpouseDiv.insertAdjacentHTML('beforebegin', this.BuildSpouseDiv(i18n)); // Set phone number mask


      this.SetPhoneMask("Spouse.Contact.MobilePhoneNumber"); // When typing into first name input also mirror in display name

      this.RegisterInputBinding("Spouse.Contact.FirstName", "Spouse.FirstNameDisplay");
    }
  }, {
    key: "AddChildDiv",
    value: function AddChildDiv(i18n) {
      var _this10 = this;

      // Insert html
      this._$insertChildDiv.insertAdjacentHTML('beforebegin', this.BuildChildDiv(i18n, this._childDivCounter)); // When typing into first name input also mirror in display name


      this.RegisterInputBinding("Children[" + this._childDivCounter + "].Contact.FirstName", "Children[" + this._childDivCounter + "].FirstNameDisplay"); // Attach event click handlers

      var removeChildDiv = this._baseRoot.getElementById("Children[" + this._childDivCounter + "]");

      removeChildDiv.addEventListener("click", function (event) {
        event.preventDefault();

        _this10.RemoveChildDiv(removeChildDiv.id);
      }); // Add dropdowns

      var genderId = this._baseRoot.getElementById("Children[" + this._childDivCounter + "].Contact.GenderId");

      DropdownBuilder.LoadDropdown(genderId, this._gendersData, i18n.genderPlaceholderText);

      var ageOrGradeId = this._baseRoot.getElementById("Children[" + this._childDivCounter + "].AgeAndGradeGroup");

      DropdownBuilder.LoadDropdown(ageOrGradeId, this._ageOrGradeData, i18n.ageAndGradeGroupLabel); // Add event listener

      var dateOfBirthId = this._baseRoot.getElementById("Children[" + this._childDivCounter + "].Contact.DateOfBirth");

      dateOfBirthId.addEventListener("change", function (event) {
        var eventTargetId = event.target.id;
        var childDivId = eventTargetId.slice(0, eventTargetId.indexOf("]") + 1);

        _this10.GetAgeOrAgeGradeDropdown(i18n, _this10._congregationId, event.target.value, childDivId + '.AgeAndGradeGroup');
      }); // Increment counter

      this._childDivCounter = this._childDivCounter + 1;
    }
  }, {
    key: "RemoveChildDiv",
    value: function RemoveChildDiv(divId) {
      // Hide dynamically added div
      var childDivToHide = divId + 'Div';

      var elemToHide = this._baseRoot.getElementById(childDivToHide);

      elemToHide.style.display = "none"; // Need to find and remove required attribute from children, otherwise validation may not pass

      var requiredElements = elemToHide.querySelectorAll('[required]');

      for (var i = 0; i < requiredElements.length; i++) {
        //requiredElements[i].removeAttribute("required");
        requiredElements[i].remove();
      } // Add and set form element to be marked for deletion, the backend api will handle the actual removal


      var elementToRemove = "\n\t\t\t<div class=\"mppw-row\">\n\t\t\t\t<div class=\"mppw-col\">\n\t\t\t\t\t<input type=\"hidden\" name=\"".concat(divId, ".MarkedForDeletion\" value=\"true\" />\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");
      elemToHide.insertAdjacentHTML('afterbegin', elementToRemove);
    }
  }, {
    key: "DisableVerificationButton",
    value: function DisableVerificationButton() {
      this._$verificationButton.setAttribute("disabled", true);
    }
  }, {
    key: "EnableVerificationButton",
    value: function EnableVerificationButton() {
      this._$verificationButton.removeAttribute("disabled");
    }
  }, {
    key: "GetAgeOrAgeGradeDropdown",
    value: function GetAgeOrAgeGradeDropdown(i18n) {
      var congregationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var dateOfBirth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var setSpecificDivDropdown = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      if (congregationId === '') {
        congregationId = 0;
      }

      if (congregationId === 0) {
        // Get first element in campus dropdown, if null leave congregationid as 0
        if (!!this._$congregationId.value) {
          congregationId = this._$congregationId.value;
        }
      } // Get age or grade groups


      this._GetAgeOrGradeGroupsService(congregationId, dateOfBirth, setSpecificDivDropdown, i18n);
    }
  }, {
    key: "_GetAgeOrGradeGroupsService",
    value: function () {
      var _GetAgeOrGradeGroupsService2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(congregationId, dateOfBirth, setSpecificDivDropdown, i18n) {
        var _this11 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._planYourVisitService.GetAgeOrGradeGroups(congregationId).then(function (data) {
                  _this11._ageOrGradeData = data.ageOrGradeGroups;

                  if (dateOfBirth) {
                    var ageDataSorted = _this11.SortAgeGradeDropdown(_this11._ageOrGradeData, dateOfBirth);
                  } // Re-bind dropdowns to newly selected age or grade group values


                  if (_this11._childDivCounter > 0 && setSpecificDivDropdown === '') {
                    for (var i = 0; i < _this11._childDivCounter; i++) {
                      var ageOrGradeId = _this11._baseRoot.getElementById("Children[" + i + "].AgeAndGradeGroup");

                      DropdownBuilder.LoadDropdown(ageOrGradeId, _this11._ageOrGradeData, i18n.ageAndGradeGroupLabel);
                    }
                  } else if (setSpecificDivDropdown) {
                    var _ageOrGradeId = _this11._baseRoot.getElementById(setSpecificDivDropdown);

                    DropdownBuilder.LoadDropdown(_ageOrGradeId, _this11._ageOrGradeData, i18n.ageAndGradeGroupLabel);
                  }
                })["catch"](function (error) {
                  console.error(error);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _GetAgeOrGradeGroupsService(_x2, _x3, _x4, _x5) {
        return _GetAgeOrGradeGroupsService2.apply(this, arguments);
      }

      return _GetAgeOrGradeGroupsService;
    }()
  }, {
    key: "SortAgeGradeDropdown",
    value: function SortAgeGradeDropdown(input, dateOfBirth) {
      var age = this._dateFormatter.GetTotalMonthsBetweenDates(new Date(dateOfBirth), new Date());

      input.sort(function (groupA, groupB) {
        var promotionAgeA = groupA.ageInMonthsToPromote;
        var promotionAgeB = groupB.ageInMonthsToPromote;
        var ageDifferenceA = promotionAgeA - age;
        var ageDifferenceB = promotionAgeB - age;
        var comparison = 0;

        if (ageDifferenceA < 0 || ageDifferenceB < 0) {
          comparison = ageDifferenceB - ageDifferenceA;
        } else {
          comparison = ageDifferenceA - ageDifferenceB;
        }

        return comparison;
      });
      return input;
    }
  }, {
    key: "GetI18NMessageByName",
    value: function GetI18NMessageByName(i18n, name) {
      var keys = Object.keys(i18n);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];

        if (key === name) {
          return i18n[key];
        }
      }
    }
  }, {
    key: "DisableSubmitButton",
    value: function DisableSubmitButton() {
      this._$submitRegistrationButton.setAttribute("disabled", true);
    }
  }, {
    key: "EnableSubmitButton",
    value: function EnableSubmitButton() {
      this._$submitRegistrationButton.removeAttribute("disabled");
    }
  }, {
    key: "BuildRootRegisterHtml",
    value: function BuildRootRegisterHtml(i18n) {
      return "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\n\t\t\t<div class=\"mppw-component-container\">\n\n\t\t\t\t<div id=\"emptyContainer\"><i class=\"mppw-spinner\"></i></div>\n\t\t\t\t<div id=\"detailsContainer\"></div>\n\n\t\t\t\t<div class=\"mppw-form-wrapper\">\n\t\t\t\t\t<h1>Plan Your Visit</h1>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"mpp-form--container\" id=\"formContainer\">\n\t\t\t\t\t<div id=\"visitDetailsContainer\">\n\t\t\t\t\t\t<div id=\"userHasVisitDetailsContainer\"></div>\n\t\t\t\t\t\t<div id=\"visitDetailsFormContainer\">\n\t\t\t\t\t\t\t").concat(this.BuildVisitDetailsForm(i18n), "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div id=\"resultMessageContainer\" class=\"mppw-alert\" style=\"display: none;\">\n\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t<span id=\"resultMessageText\" class=\"mppw-alert__text\"></span>\n\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t");
    }
  }, {
    key: "BuildRootInitialHtml",
    value: function BuildRootInitialHtml(i18n) {
      return "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\n\t\t\t<div id=\"mpp-plan-your-visit-container\" class=\"mppw-component-container mpp-plan-your-visit\">\n\n\t\t\t\t<div id=\"emptyContainer\"><i class=\"mppw-spinner\"></i></div>\n\t\t\t\t<div id=\"detailsContainer\"></div>\n\n\t\t\t\t<div class=\"mppw-form-wrapper\">\n\t\t\t\t\t<h1>").concat(i18n.pageTitle, "</h1>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"mpp-form--container\" id=\"formContainer\">\n\t\t\t\t\t<div id=\"verfificationContainer\">\n\t\t\t\t\t\t<div id=\"userHasVerificationContainer\"></div>\n\t\t\t\t\t\t").concat(this.BuildVerificationForm(i18n), "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t");
    }
  }, {
    key: "BuildSpouseDiv",
    value: function BuildSpouseDiv(i18n) {
      return "\n\t\t<div class=\"mppw-row\">\n\t\t\t\t<div class=\"mppw-col\">\n\t\t\t\t\t<h4><span id=\"Spouse.FirstNameDisplay\"></span> (Spouse)</h4>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"mppw-row\">\n\t\t\t\t<div class=\"mppw-col\">\n\t\t\t\t\t".concat(this._formFieldBuilder.BuildTextInput('Spouse.Contact.FirstName', i18n.firstNameLabel, false), "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mppw-col\">\n\t\t\t\t\t<div data-id=\"Spouse.Contact.LastName\" data-depends-on-value=\"\" class=\"mppw-form-field mpp-mt-10\">\n\t\t\t\t\t<input type=\"text\" id=\"Spouse.Contact.LastName\" name=\"Spouse.Contact.LastName\" required data-require-if=\"Spouse.Contact.FirstName\" class=\"mppw-form-field__control\" value=\"").concat(this.userToRegister.lastName, "\" maxlength=\"250\" minlength=\"0\" />\n\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"Spouse.Contact.LastName\">Last Name:</label>\n\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"mppw-row\">\n\t\t\t\t<div class=\"mppw-col\">\n\t\t\t\t\t").concat(this._formFieldBuilder.BuildEmailInput('Spouse.Contact.EmailAddress', i18n.emailAddressLabel, false), "\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mppw-col\">\n\t\t\t\t\t").concat(this._formFieldBuilder.BuildPhoneInput('Spouse.Contact.MobilePhoneNumber', i18n.mobilePhoneLabel, false), "\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t");
    }
  }, {
    key: "BuildAddressDiv",
    value: function BuildAddressDiv(i18n) {
      if (this.collectAddress === "true") {
        return "\n\t\t<div class=\"mppw-row\">\n\t<div class=\"mppw-col\">\n\t\t<h4>Address</h4>\n\t</div>\n</div>\n\t<div class=\"mppw-row\">\n\t\t<div class=\"mppw-col\">\n\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t<select name=\"HouseholdAddress.Country\" class=\"mppw-form-field__control search-option\" id=\"countryId\" value=\"\" required></select>\n\t\t\t\t<label class=\"mppw-form-field__label\" for=\"HouseholdAddress.Country\">".concat(i18n.countryLabel, "*</label>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"mppw-row\">\n\t\t<div class=\"mpp-planyourvisit-col-12\">\n\t\t\t").concat(this._formFieldBuilder.BuildTextInput('HouseholdAddress.AddressLine1', i18n.registrationAddressLabel, true, 'Address is required'), "\n\t\t</div>\n\t</div>\n\t<div class=\"mppw-row\">\n\t\t<div class=\"mpp-planyourvisit-col-4\">\n\t\t\t").concat(this._formFieldBuilder.BuildTextInput('HouseholdAddress.City', i18n.registrationCityLabel, true, 'City is required'), "\n\t\t</div>\n\t\t<div class=\"mpp-planyourvisit-col-4\">\n\t\t\t").concat(this._formFieldBuilder.BuildTextInput('HouseholdAddress.StateOrProvince', i18n.registrationStateLabel, true, 'State is required'), "\n\t\t</div>\n\t\t<div class=\"mpp-planyourvisit-col-4\">\n\t\t\t").concat(this._formFieldBuilder.BuildTextInput('HouseholdAddress.PostalCode', i18n.registrationZipCodeLabel, true, 'Zip Code is required'), "\n\t\t</div>\n\t</div>\n\t\t");
      } else {
        return '<div></div>';
      }
    }
  }, {
    key: "BuildChildDiv",
    value: function BuildChildDiv(i18n, counter) {
      return "\n\t\t\t<div id=\"Children[".concat(counter, "]Div\">\n\t\t<div class=\"mppw-row\">\n\t\t\t<h4 class=\"mpp-plan-your-visit--floatLeft\"><span id=\"Children[").concat(counter, "].FirstNameDisplay\"></span> (Child)</h4>\n\t\t\t<h5 class=\"mpp-plan-your-visit--floatRight\">\n\t\t\t\t<a id=\"Children[").concat(counter, "]\" class=\"removeChildClass mpp-plan-your-visit--header-wrapper mpp-planyourvisit--link mpp-planyourvisit--text-red\" href=\"#\" data-searchmode=\"0\">\n\t\t\t\t\t<img class=\"mpp-planyourvisit--icon\" src=\"").concat(this._appRoot, "/Content/icons/minus-circle.png\" />\n\t\t\t\t\t<span class=\"edit\" style=\"vertical-align: super;\">Remove child</span>\n\t\t\t\t</a>\n\t\t\t</h5>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('Children[' + counter + '].Contact.FirstName', i18n.firstNameLabel, true, 'First name is required'), "\n\t\t\t</div>\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('Children[' + counter + '].Contact.LastName', i18n.lastNameLabel, true, 'Last name is required', this.userToRegister.lastName), "\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildDateInput('Children[' + counter + '].Contact.DateOfBirth', i18n.dateOfBirthLabel, true), "\n\t\t\t</div>\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t\t<select name=\"").concat('Children[' + counter + '].Contact.GenderId', "\" class=\"mppw-form-field__control search-option\" id=\"").concat('Children[' + counter + '].Contact.GenderId', "\" value=\"\" required></select>\n\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"").concat('Children[' + counter + '].Contact.GenderId', "\">").concat(i18n.genderLabel, "*</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t\t<select name=\"").concat('Children[' + counter + '].AgeAndGradeGroup', "\" class=\"mppw-form-field__control search-option\" id=\"").concat('Children[' + counter + '].AgeAndGradeGroup', "\" value=\"\" required></select>\n\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"").concat('Children[' + counter + '].AgeAndGradeGroup', "\">").concat(i18n.ageAndGradeGroupLabel, "*</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t\t");
    }
  }, {
    key: "BuildVerificationForm",
    value: function BuildVerificationForm(i18n) {
      return "\n\t\t<div class=\"mpp-innerpage\">\n\t<p>".concat(i18n.verificationDescription, "</p>\n</div>\n<div class=\"mpp-innerpage\">\n\t<h3>").concat(i18n.subHeaderText, "</h3>\n</div>\n<div id=\"invalidVerificationEmailContainer\"></div>\n <div id=\"resultMessageContainer\" class=\"mppw-alert\" style=\"display: none;\">\n\t <div class=\"mppw-alert__icon\"></div>\n\t <span id=\"resultMessageText\" class=\"mppw-alert__text\"></span>\n </div>\n<div id=\"loginButtonContainer\" class=\"mppw-centered\" style=\"display: none;\">\n\t\t\t\t\t<input type=\"button\" class=\"mppw-btn primary\" id=\"loginButton\" value=\"Login\" />\n\t\t\t\t</div>\n\t<form name=\"verificationForm\" id=\"verificationForm\" class=\"mppw-form mppw-form-validate\" style=\"display: none;\">\n<input type=\"hidden\" name=\"VerificationEmailTemplate\" value=\"").concat(this.verificationEmailTemplate || '', "\" />\n<div id=\"verificationGroupDiv\">\n<div id=\"verificationBlankForm\">\n\t\t\t<div class=\"form--row\">\n\t\t\t<div class=\"form--col\">\n\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t<input name=\"FirstName\" id=\"verification_firstNameText\" type=\"text\" class=\"mppw-form-field__control\" required value=\"\" />\n\t\t\t\t<label class=\"mppw-form-field__label\" for=\"verification_firstNameText\">").concat(i18n.firstNameLabel, "*:</label>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form--row\">\n\t\t\t<div class=\"form--col\">\n\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t<input name=\"LastName\" type=\"text\" id=\"verification_lastNameText\" class=\"mppw-form-field__control\" required value=\"\" />\n\t\t\t\t<label class=\"mppw-form-field__label\" for=\"verification_lastNameText\">").concat(i18n.lastNameLabel, "*:</label>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form--row\">\n\t\t\t<div class=\"form--col\">\n\t\t\t<div class=\"mppw-form-field  mppw-form-field__static-container\">\n\t\t\t\t<input name=\"EmailAddress\" id=\"verification_emailText\" type=\"email\" class=\"mppw-form-field__control\" required value=\"\" />\n\t\t\t\t<label class=\"mppw-form-field__label\" for=\"verification_emailText\">").concat(i18n.emailAddressLabel, "*:</label>\n\t\t\t</div>\n\t\t\t</div>\n\t\t\t</div>\n\t<div class=\"mppw-centered\">\n\t\t<input id=\"verificationButton\" type=\"submit\" class=\"mppw-btn primary\" value=\"").concat(i18n.submitVerificationButtonText, "\" />\n\t</div>\n</div>\n</div>\n</form>\n\t\t");
    }
  }, {
    key: "BuildVisitDetailsForm",
    value: function BuildVisitDetailsForm(i18n) {
      return "\n\t <div class=\"mpp-innerpage\">\n\t\t<p>Please fill out the information below so that we can make your experience special.</p>\n\t</div>\n\t<div class=\"mpp-innerpage\">\n\t\t<h2>".concat(i18n.subHeaderText || '', "</h2>\n\t</div>\n\t<form id=\"visitDetailsForm\" class=\"mppw-form mppw-form-validate\">\n\t\t<input type=\"hidden\" name=\"HeadOfHousehold.Contact.EmailAddress\" value=\"").concat(this.userToRegister.email, "\" />\n\t\t<input type=\"hidden\" name=\"UserNotificationEmailTemplate\" value=\"").concat(this.userNotificationEmailTemplate || '', "\" />\n\t\t<input type=\"hidden\" name=\"ChurchNotificationEmailTemplate\" value=\"").concat(this.churchNotificationEmailTemplate || '', "\" />\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<h3>Visit Details</h3>\n\t\t\t</div>\n\t\t<div id=\"invalidDetailsEmailTemplateContainer\"></div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t\t<select name=\"HeadOfHousehold.Contact.CongregationId\" class=\"mppw-form-field__control search-option\" id=\"congregationId\" value=\"\" required></select>\n\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"HeadOfHousehold.Contact.CongregationId\">").concat(i18n.congregationLabel, "*</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('WhenCanWeExpectYou', i18n.registrationWhenToExpectYouLabel, true, 'When can we expect you is required'), "\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<h3>Personal Details</h3>\n\t\t\t\t<h4>Contact</h4>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t<div class=\"mpp-planyourvisit-col-12\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('HeadOfHousehold.Contact.FirstName', i18n.firstNameLabel, true, i18n.firstNameRequired, this.userToRegister.firstName), "\n\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"mppw-row\">\n\t\t<div class=\"mpp-planyourvisit-col-12\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildTextInput('HeadOfHousehold.Contact.LastName', i18n.lastNameLabel, true, i18n.lastNameRequired, this.userToRegister.lastName), "\n\t\t</div>\n\t\t</div>\n\t\t\t\t<div class=\"mppw-row\">\n\t\t\t\t<div class=\"mpp-planyourvisit-col-12\">\n\t\t\t\t<div class=\"mppw-form-field mppw-form-field__static-container\">\n\t\t\t\t\t<input type=\"email\" id=\"EmailReadOnly\" name=\"EmailReadOnly\" class=\"mppw-form-field__control mpp-plan-your-visit--readonly\"\n\t\t\t\t\t\tvalue=\"").concat(this.userToRegister.email, "\" readonly />\n\t\t\t\t\t<label class=\"mppw-form-field__label\" for=\"EmailReadOnly\">").concat(i18n.emailAddressLabel, ":</label>\n\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t</div>\n\n<div class=\"mppw-row\">\n\t\t\t\t\t<div class=\"mpp-planyourvisit-col-12\">\n\t\t\t\t").concat(this._formFieldBuilder.BuildPhoneInput('HeadOfHousehold.Contact.MobilePhoneNumber', i18n.mobilePhoneLabel, true, i18n.mobilePhoneRequired), "\n</div>\n</div>\n\n\t\t").concat(this.BuildAddressDiv(i18n), "\n\t\t<div class=\"mppw-row\" >\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<h3>Additional Family Members</h3>\n\t\t\t</div>\n\t\t</div>\n\t\t<div id=\"insertSpouseDiv\"></div>\n\t\t<div id=\"childDivWrapper\">\n\t\t\t<div id=\"insertChildDiv\"></div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<div class=\"mpp-plan-your-visit--header-container\">\n\t\t\t\t\t<a id=\"addChildButton\" class=\"mpp-plan-your-visit--header-wrapper mpp-planyourvisit--link\" href=\"#\" data-searchmode=\"0\">\n\t\t\t\t\t\t<img class=\"mpp-icon--household\" src=\"").concat(this._appRoot, "/Content/icons/icon-household-add-member.svg\" />\n\t\t\t\t\t\t<span class=\"edit\" style=\"vertical-align: super;\">Add child</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"mppw-row\">\n\t\t\t<div class=\"mppw-col\">\n\t\t\t</div>\n\t\t\t<div class=\"mppw-col\">\n\t\t\t\t<div class=\"mppw-col-item\">\n\t\t\t\t\t<input id=\"submitRegistrationButton\" type=\"submit\" class=\"mppw-btn primary\" value=\"").concat(i18n.submitRegistrationButtonLabel, "\" />\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</form>\n\n\t\t");
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Plan Your Visit",
        tag: "mpp-plan-your-visit",
        configurationItems: [{
          name: "Return URL",
          attribute: "returnurl",
          description: "Defines the navigation path to the Plan Your Visit Widget. Used by verification email to resume Plan Your Visit. This is the URL for the page where the Plan Your Visit Widget is placed. Must be a fully qualified URL.",
          required: true,
          type: "url"
        }, {
          name: "Verification Email Template",
          attribute: "verificationemailtemplateId",
          description: "Email containing a validation link allowing an individual to proceed. Valid Value: Message ID.",
          required: true,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }, {
          name: "Church Notification Template",
          attribute: "churchnotificationemailtemplateid",
          description: "Email notifying a designated point of contact. Valid value: Message ID.",
          required: true,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }, {
          name: "Show/Hide Address",
          attribute: "collectaddress",
          description: "Determines whether the form will require an address. When disabled, these features are hidden.",
          required: true,
          type: "bool"
        }, {
          name: "Milestone to Assign",
          attribute: "milestonetoassignid",
          description: "Determines which Milestone will be assigned to those who plan their visit. Valid value: Milestone ID.",
          required: true,
          type: "foreignkey",
          fkTable: "Milestones",
          fkFilter: "",
          fkSingleName: "Milestone"
        }, {
          name: "Milestone Program",
          attribute: "milestoneprogramid",
          description: "Determines which Program will be credited in the Milestone Assigned record. Valid Value: Program ID.",
          required: true,
          type: "foreignkey",
          fkTable: "Programs",
          fkFilter: "",
          fkSingleName: "Program"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["verificationemailtemplateId", "returnurl", "userNotificationemailtemplateid", "churchnotificationemailtemplateid", "collectaddress", "milestonetoassignid", "milestoneprogramid"];
    }
  }]);

  return MppPlanYourVisit;
}(ComponentBase);
MppPlanYourVisit.registerComponent(MppPlanYourVisit.WidgetDetails.tag, MppPlanYourVisit);